import Image from '@/components/UI/Image';
import { handleMultiProductImages } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { Fragment } from 'react';
import css from './index.module.scss';
export default function supportRightContent({ content }: any) {
    const { Link, gtm } = useGlobal();

    const onClick = (item: any, type: string) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'select_product',
            list_name: item.listName,
            product_name: item.name,
            button_name: type,
        });
    };

    return (
        <div className={css.accContent}>
            <ul style={{ borderBottom: content?.length > 0 ? '1px solid #ebe9e9' : 'none' }}>
                {content?.map((item: any, i: any) => (
                    <Fragment key={i}>
                        {i != 0 && i % 4 == 0 && <div className="line"></div>}
                        <li key={item.name}>
                            <Link href={item.buyLink} ariaLabel={item.name} newWin>
                                <div className="imgs">
                                    <Image
                                        src={item.images ? handleMultiProductImages(item.images, 'list') : '/img/news.png'}
                                        width="188"
                                        height="188"
                                        className="fullImgs"
                                        alt={item.name}
                                        onClick={() => onClick(item, 'Image')}
                                    />
                                </div>
                                <h4 className="font-family-medium" onClick={() => onClick(item, 'Title')}>
                                    {item.name}
                                    <span className="price">
                                        {item.unit}
                                        {item.price}
                                    </span>
                                </h4>
                            </Link>
                        </li>
                    </Fragment>
                ))}
            </ul>
        </div>
    );
}
